module.exports = __webpack_public_path__ + "static/media/default.9093e921.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/noSorrow/index/default.jpg
// module id = 1202
// module chunks = 0